import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { FixedSizeList } from "react-window";
import { openVideoList } from "../../../helpers/service";
import axios from "axios";
import { excludeAttackingTypesParameters } from "../../../helpers/teamParameterGroups";

// Style
import {
  MainWrapper,
  TopWrapper,
  MainWrapperFavorite,
} from "../../../style/DasboardMain";
import "react-tabs/style/react-tabs.css";
import { NotificationList } from "../../../components/notification/NotificationList";
// Components
import Navigation from "../../../components/Navigation/Navigation";
import IntroText from "../../../components/introText/index";
import Search from "../../../components/inputs/Search";

// Language
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import SmrtSearchTable from "../../../components/table/SmrtSearchTable";
import MatchTable, { DropdownWrapper } from "../../../components/table/MatchTable";

// Images
import placeholder from "../../../images/ic_logo.svg";
import yellowCard from "../../../images/ic_yellow-card.svg";
import redCard from "../../../images/ic_red-card.svg";
import substitution from "../../../images/ic_substition.svg";
import goal from "../../../images/ic_goal.svg";
import injury from "../../../images/ic_injury.svg";
import arrowIconUp from "../../../images/up.svg";
import arrowIconDown from "../../../images/down.svg";
import metricaBlack from "../../../images/metrica-black-logo.png"

import { useNotification } from "../../../components/notification/useNotification";

import Moment from "react-moment";
import { TeamButtons } from "../player/Index";
import Button from "../../../components/button";
import {
  TabContent,
  TabListWrapper,
  TabsWrapper,
  TabTitle,
  TopList,
} from "../../../style/Favorites";
import PlayersStat from "../../../components/table/PlayersStat";
import GoalKeeperStat from "../../../components/table/GoalKeeperStat";
import { breakpoints } from "../../../style/size";
import Filter, { FormWrap } from "../../../components/modal/Filter";
import TextInput, { InputWrapper } from "../../../components/inputs/TextInput";
import { $apiV1, $apiV2 } from "../../../config/api";
import { AccessDenied, TeamPageContainer } from "../team/Index";
import { Formation } from "../../../components/Formation";
import { getGroupedAndSortedParametrs } from "../../../helpers";
import { playersModalParams } from "../../../config/parametrs/playersModalParams";
import { goalkeepersModalParams } from "../../../config/parametrs/goalkeepersModalParams";
import ParamFilter from "./ParamFilter";
import { Overlay } from "../../../components/modal";
import {
  Content,
  ModalWrapper,
} from "../../../components/ParametersSelector/ParametersModal";
import { ActionButtonsContainer, ParametersSelector } from "../../../components/ParametersSelector";
import useOutsideClick from "../../../hooks/useOutsideClick";
import { useLexicon } from "../../../hooks/useLexicon";
import { useSelector } from "react-redux";
import { getMediaUrl } from "../../../helpers";
import { formatMatchScore } from "../../../helpers/matchScore";
import { useParameterLexicon } from "../../../hooks/useParameterLexicon";
import { createTranslatedParameterNameResolver } from "./parameterDisplayName";
import {
  buildMatchEventDescription,
  buildMatchEventVideoTitle,
  resolveMatchEventLabel,
} from "./matchEventDisplayName";
import { getActiveParameterSelection } from "./playerParameterSelection";

// Map an event action title to its icon. Resolved once per marker while building
// the memoized view-model instead of via nested ternaries on every render.
const MATCH_EVENT_ICONS = {
  "Yellow card": yellowCard,
  "Red card": redCard,
  Substitution: substitution,
  Goal: goal,
  Injury: injury,
};

// Virtualized marker list geometry. Only the rows visible inside this height are
// mounted, so a match with 1000+ events no longer builds thousands of DOM nodes.
const MARKER_LIST_HEIGHT = 340;
const MARKER_ROW_HEIGHT = 46;

// Build a Map of parameter_name -> stat for O(1) lookup during render.
// Avoids running a linear .find() per parameter cell across hundreds of cells.
const statsByParameterName = (stats) => {
  const map = new Map();
  if (Array.isArray(stats)) {
    for (const stat of stats) {
      if (stat?.parameter_name != null && !map.has(stat.parameter_name)) {
        map.set(stat.parameter_name, stat);
      }
    }
  }
  return map;
};

export const TeamCardWrap = styled.div`
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.borderColor};
  box-shadow: 3px 2px 30px rgba(68, 68, 68, 0.12);
  opacity: 1;
  background-color: ${(props) => props.theme.sidebar};
  margin-bottom: 60px;
`;

const PopupOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 9999;
`;

const PopupContent = styled.div`
  background: #000000;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  padding: 32px 40px;
  max-width: 520px;
  width: 100%;
  text-align: center;
`;

const PopupMessage = styled.p`
  color: ${(props) => props.theme.white};
  font-family: "SatoshiMedium";
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 24px;
`;

const PopupActions = styled.div`
  display: flex;
  justify-content: center;
`;

export const DownloadXml = styled.div`
  text-align: right;

  button {
    border-radius: 1px;
    border: none;
    opacity: 1;
    background-color: ${(props) => props.theme.green};
    color: ${(props) => props.theme.black};
    opacity: 1;
    font-family: "SpaceGrotesk";
    font-size: 16px;
    font-weight: 700;
    font-style: Bold;
    letter-spacing: 0.5px;
    text-align: center;
    line-height: 24px;
    text-transform: uppercase;
    padding: 0 10px;
    height: 40px;
    cursor: pointer;
  }
`;

export const TeamContent = styled.div`
  padding: 20px;
`;

export const TopContent = styled.div`
  display: flex;
  align-items: end;
  justify-content: space-between;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(24, 25, 24, 1);

  img {
    width: 80px;
    height: 80px;
    object-fit: contain;
  }

  @media only screen and (${breakpoints.mobile}) {
    flex-direction: column;
    gap: 35px;
  }
`;

export const Info = styled.div`
  display: flex;
  gap: 16px;

  @media only screen and (${breakpoints.mobile}) {
    align-items: center;
    width: 100%;
  }
`;

export const BottomContent = styled.div``;

export const Result = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 20px;
  position: relative;

  @media only screen and (${breakpoints.mobile}) {
    flex-direction: column;
  }

  h5 {
    opacity: 1;
    color: ${(props) => props.theme.white};
    font-family: "SatoshiBold";
    font-size: 36px;
    font-weight: 700;
    font-style: Bold;
    letter-spacing: 4px;
    text-align: center;
    line-height: 50px;
    position: absolute;
    // margin-left: -10vw;
    width: 100%;

    @media only screen and (${breakpoints.mobile}) {
      font-size: 20px;
      line-height: 30px;
      position: relative;
      margin-left: 0;
      width: auto;
    }
  }
`;

export const TeamInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 1;

  &.reverse {
    flex-direction: row-reverse;

    @media only screen and (${breakpoints.mobile}) {
      flex-direction: row;
    }
  }

  img {
    width: 40px;
    height: 40px;
    object-fit: contain;
  }

  a {
    opacity: 1;
    color: ${(props) => props.theme.white};
    font-family: "SatoshiMedium";
    font-size: 28px;
    font-weight: 500;
    font-style: Medium;
    letter-spacing: 0px;
    text-align: left;
    line-height: 38px;
    text-decoration: none;

    width: 30vw;
    max-width: fit-content;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
      text-decoration: underline;
    }

    @media only screen and (${breakpoints.mobile}) {
      font-size: 16px;
      width: 100%;
    }
  }

  .react-tooltip {
    background: #cfdae6;
    opacity: 1;
    color: rgba(4, 8, 2, 1);
    font-family: "SatoshiBold";
    font-size: 16px;
    font-weight: 700;
    font-style: Bold;
    letter-spacing: 0px;
    text-align: center;
    line-height: 24px;
  }
`;

export const TeamLeftInfo = styled.div`
  h5 {
    opacity: 1;
    color: rgba(115, 128, 137, 1);
    font-family: "SatoshiMedium";
    font-size: 12px;
    font-weight: 500;
    font-style: Medium;
    letter-spacing: 0px;
    text-align: left;
    line-height: 18px;

    time {
      opacity: 1;
      color: rgba(115, 128, 137, 1);
      font-family: "SatoshiMedium";
      font-size: 12px;
      font-weight: 500;
      font-style: Medium;
      letter-spacing: 0px;
      text-align: left;
      line-height: 18px;
    }
  }

  h2 {
    opacity: 1;
    color: ${(props) => props.theme.white};
    font-family: "SatoshiMedium";
    font-size: 28px;
    font-weight: 500;
    font-style: Medium;
    letter-spacing: 0px;
    text-align: left;
    line-height: 38px;

    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;

    @media only screen and (${breakpoints.mobile}) {
      font-size: 24px;
    }

    &.statText {
      max-width: 30vw;
      overflow: hidden;
      display: inline-block;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }

      @media only screen and (${breakpoints.mobile}) {
        max-width: 65vw;
      }
    }
  }

  h3 {
    opacity: 1;
    color: ${(props) => props.theme.white};
    font-family: "SatoshiRegular";
    font-size: 16px;
    font-weight: 400;
    font-style: Regular;
    letter-spacing: 0px;
    text-align: left;
    line-height: 24px;
  }
`;

export const TeamRightInfo = styled.div`
  padding-right: 70px;
  ul {
    li {
      opacity: 1;
      color: rgba(115, 128, 137, 1);
      font-family: "SatoshiMedium";
      font-size: 16px;
      font-weight: 500;
      font-style: Medium;
      letter-spacing: 0px;
      text-align: left;
      line-height: 24px;
    }
  }
`;

export const Stat = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TeamStatistics = styled.div`
  padding-top: 20px;

  h5 {
    opacity: 1;
    color: rgba(115, 128, 137, 1);
    font-family: "SatoshiRegular";
    font-size: 12px;
    font-weight: 400;
    font-style: Regular;
    letter-spacing: 0px;
    text-align: left;
    line-height: 18px;
  }

  h4 {
    opacity: 1;
    color: rgba(207, 218, 230, 1);
    font-family: "SatoshiMedium";
    font-size: 16px;
    font-weight: 500;
    font-style: Medium;
    letter-spacing: 0px;
    text-align: left;
    line-height: 24px;
  }
`;

export const StatCardsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
`;

export const StatCard = styled.div`
  width: 48%;
  border-radius: 4px;
  opacity: 1;

  @media only screen and (${breakpoints.mobile}) {
    width: 100%;
  }
`;

export const TopStatCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  h2 {
    opacity: 1;
    color: ${(props) => props.theme.white};
    font-family: "SatoshiRegular";
    font-size: 20px;
    font-weight: 400;
    font-style: Regular;
    letter-spacing: 0px;
    text-align: left;
    line-height: 30px;
  }

  button {
    border-radius: 1px;
    border: none;
    opacity: 1;
    background-color: ${(props) => props.theme.green};
    opacity: 1;
    color: ${(props) => props.theme.black};
    font-family: "SpaceGrotesk";
    font-size: 16px;
    font-weight: 700;
    font-style: Bold;
    letter-spacing: 0.5px;
    text-align: center;
    line-height: 24px;
    text-transform: uppercase;
    min-width: 92px;
    height: 40px;
    cursor: pointer;
  }
`;

export const InnerCardInfo = styled.div`
  border: 1px solid ${(props) => props.theme.borderColor};
  box-shadow: 3px 2px 30px rgba(68, 68, 68, 0.12);
  opacity: 1;
  background-color: ${(props) => props.theme.sidebar};
  height: 400px;
  overflow: auto;
  -ms-overflow-style: auto;
  scrollbar-width: auto;
`;

export const BottomTableStat = styled.div`
  border: 1px solid ${(props) => props.theme.borderColor};
  box-shadow: 3px 2px 30px rgba(68, 68, 68, 0.12);
  opacity: 1;
  background-color: ${(props) => props.theme.sidebar};
`;

export const TeamStatInfo = styled.div``;

export const TopTeamNames = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  background: ${(props) => props.theme.black};
  padding: 5px 0;

  &:nth-child(1) {
    z-index: 1;
  }

  a {
    opacity: 1;
    color: ${(props) => props.theme.white};
    font-family: "SatoshiBold";
    font-size: 16px;
    font-weight: 700;
    font-style: Bold;
    letter-spacing: 0px;
    text-align: left;
    line-height: 24px;
    width: 30%;
    padding: 0 10px;
    text-align: right;
    text-decoration: none;

    &:nth-child(1) {
      text-align: left;
    }
  }

  select {
    border-radius: 1px;
    border: 1px solid rgba(44, 50, 48, 1);
    opacity: 1;
    background: transparent;
    color: #fff;
    height: 40px;
    opacity: 1;
    color: ${(props) => props.theme.white};
    font-family: "SatoshiMedium";
    font-weight: 500;
    font-style: Medium;
    letter-spacing: 0px;
    text-align: left;
    line-height: 24px;
    outline: none;
  }
`;

export const TeamStatHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;

  // &:nth-child(2) {
  //   width: 40%;
  // }

  h5 {
    opacity: 1;
    color: rgba(115, 128, 137, 1);
    font-family: "SatoshiMedium";
    font-size: 16px;
    font-weight: 500;
    font-style: Medium;
    letter-spacing: 0px;
    text-align: center;
    line-height: 24px;
    text-transform: uppercase;
    margin: auto;

    &.aboveSpace {
      margin-top: 20px;
    }
  }
`;

export const TeamInfoStat = styled.div`
  display: flex;
  flex-direction: column;

  h5 {
    opacity: 1;
    color: ${(props) => props.theme.white};
    font-family: "SatoshiBold";
    font-size: 16px;
    font-weight: 700;
    font-style: Bold;
    letter-spacing: 0px;
    text-align: left;
    line-height: 24px;
  }
`;

export const InfoStat = styled.div`
  padding: 0 10px;
  &:nth-child(even) {
    background: ${(props) => props.theme.black};
  }
`;

export const MatchEvent = styled.div`
  border: 1px solid ${(props) => props.theme.borderColor};
  box-shadow: 3px 2px 30px rgba(68, 68, 68, 0.12);
  opacity: 1;
  background-color: ${(props) => props.theme.sidebar};
  height: 400px;
  overflow: auto;
  -ms-overflow-style: auto;
  scrollbar-width: auto;
`;

export const MathTitle = styled.div`
  display: flex;
  padding: 20px 0 0 10px;

  h3 {
    opacity: 1;
    color: rgba(115, 128, 137, 1);
    font-family: "SatoshiMedium";
    font-size: 12px;
    font-weight: 500;
    font-style: Medium;
    letter-spacing: 0.5px;
    text-align: left;
    line-height: 18px;

    &:nth-child(1) {
      width: 150px;
    }

    &:nth-child(2) {
      width: 100px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;
export const MatchWrap = styled.div`
  display: flex;
  padding: 10px 0px 10px 10px;
  box-sizing: border-box;

  background: ${(props) => (props.$even ? props.theme.black : "transparent")};

  img {
    object-fit: contain;
  }

  h5 {
    opacity: 1;
    color: ${(props) => props.theme.white};
    font-family: "SatoshiMedium";
    font-size: 16px;
    font-weight: 500;
    font-style: Medium;
    letter-spacing: 0px;
    text-align: left;
    line-height: 24px;
    display: flex;
    align-items: center;
    gap: 5px;

    &:nth-child(1) {
      width: 150px;
    }

    &:nth-child(2) {
      width: 100px;
    }

    &.creatorName {
      max-width: 120px;
      overflow: hidden;
      display: inline-block;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`;

export const BottomStatTable = styled.div`
  margin: 40px 0;
`;

export const ParamCheckboxStyle = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: space-between;
  padding: 10px !important;
  gap: 20px;
  white-space: nowrap;

  label {
    opacity: 1;
    color: ${(props) => props.theme.blueish};
    font-family: "SatoshiRegular";
    font-size: 16px;
    font-weight: 400;
    font-style: Regular;
    letter-spacing: 0px;
    text-align: left;
    line-height: 24px;
  }

  input[type="checkbox"] {
    appearance: none;
    background-color: transparent;
    margin: 0;
    font: inherit;
    width: 16px;
    height: 16px;
    border: 1px solid ${(props) => props.theme.green}; /* Green color */
    border-radius: 2px;
    transform: translateY(-0.075em);
    display: grid;
    place-content: center;
    cursor: pointer;
  }

  input[type="checkbox"]::before {
    content: "";
    width: 8px;
    height: 0.6em;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 21%, 80% 0, 43% 62%);
    transform: scale(0);
    transition: transform 0.15s ease-in-out;
    background-color: ${(props) =>
    props.theme.green}; /* Green color for the check */
  }

  input[type="checkbox"]:checked::before {
    transform: scale(1);
  }

  label {
  }
`;

export const ParamsWrap = styled.div`
  position: relative;
`;

export const OpenedDropdown = styled.div`
  position: absolute;
  z-index: 999;
  width: 100%;
  margin-top: 20px;
  border-radius: 2px;
  opacity: 1;
  background-color: ${(props) => props.theme.lines};
  max-height: 200px;
  overflow: scroll;
  border: 1px solid ${(props) => props.theme.borderColor};

  > div {
    opacity: 1;
    color: ${(props) => props.theme.blueish};
    font-family: "SatoshiRegular";
    font-size: 16px;
    font-weight: 400;
    font-style: Regular;
    letter-spacing: 0px;
    text-align: left;
    line-height: 24px;
    padding: 10px 6px;
    cursor: pointer;

    &:hover {
      background-color: ${(props) => props.theme.black};
    }
  }
`;

const Index = () => {
  const l = useLexicon();
  const { getPlayerParameterLexiconId, getTeamParameterLexiconId } = useParameterLexicon();
  const { t, i18n } = useTranslation();

  const matchInfo = useSelector(state => state.competiton.matchInfo);
  const canDownloadReport = useSelector(state => state.user.canDownloadReport);

  const { id } = useParams();
  const [stats, setStats] = useState([]);
  const [isDownloadingReport, setIsDownloadingReport] = useState(false);
  const [loading, setLoading] = useState(false);
  const [matchStat, setMatchStat] = useState({});
  const [matchesWithStatHome, setMathesWithStatHome] = useState([]);
  const [matchesWithStatAway, setMathesWithStatAway] = useState([]);
  const [playerStats, setPlayerStats] = useState();
  const [playerStatsLoading, setPlayerStatsLoading] = useState(true);
  const [playerFiltersLoading, setPlayerFiltersLoading] = useState(true);
  // Tracks the latest getPlayerStats call — only that call's result is applied.
  const playerStatsCallId = React.useRef(0);
  const [accessDenied, setAccessDenied] = useState(false);

  const [selectedHomePlayer, setSelectedHomePlayer] = useState("");
  const [selectedAwayPlayer, setSelectedAwayPlayer] = useState("");

  // const [selectedGkHomePlayer, setSelectedGkHomePlayer] = useState("");
  // const [selectedGkAwayPlayer, setSelectedGkAwayPlayer] = useState("");

  const [openFilter, setOpenFilter] = useState(false);
  const [openPlayerFilter, setOpenPlayerFilter] = useState(false);

  const [openParams, setOpenParams] = useState(false);

  const [openFormation, setOpenFormation] = useState(false);

  const [teamParamsList, setTeamParamsList] = useState([]);
  const [playerParamsList, setPlayerParamsList] = useState([]);
  const [playerGkParams, setPlayerGkParams] = useState([]);

  const [selectedParams, setSelectedParams] = useState([]);
  const { notifications, addNotification, removeNotification } = useNotification();


  //players filter state
  const [typePlayerStat, setTypePlayerStat] = useState('player'); // player | gk
  const [gkPlayerSelectedFilters, setGkPlayerSelectedFilters] = useState({ checkedIds: [], params: [] });
  const [playerSelectedFilters, setPlayerSelectedFilters] = useState({ checkedIds: [], params: [] });

  //selectors
  const [openOutfieldHomePlayers, setOpenOutfieldHomePlayers] = useState(false);
  const [openOutfieldAwayePlayers, setOpenOutfieldAwayPlayers] = useState(false);
  const [openGkHomePlayers, setOpenGkHomePlayers] = useState(false);
  const [openGkAwayePlayers, setOpenGkAwayPlayers] = useState(false);

  const [selectedOutfieldHomePlayer, setSelectedOutfieldHomePlayer] = useState(filterPlayers(
    playerStats?.players_stats?.home_team
  )?.[0] || null)

  const [selectedOutfieldAwayPlayer, setSelectedOutfieldAwayPlayer] = useState(filterPlayers(
    playerStats?.players_stats?.away_team
  )?.[0] || null)

  const [selectedGkHomePlayer, setSelectedGkHomePlayer] = useState(filterGK(
    playerStats?.players_stats?.home_team
  )?.[0] || null)

  const [selectedGkAwayPlayer, setSelectedGkAwayPlayer] = useState(filterGK(
    playerStats?.players_stats?.away_team
  )?.[0] || null)
  const [xmlFileName, setXmlFileName] = useState('match.xml');
  const navigate = useNavigate();


  useEffect(() => {
    // Initialize selectedParams with all parameters
    const allParams = teamParamsList.map(([key]) => key);
    setSelectedParams(allParams);
  }, [teamParamsList]);

  useEffect(() => {
    $apiV2.get('/access/check/' + id + '/match')
      .then(() => {
        setAccessDenied(false);
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          setAccessDenied(true);
          setTimeout(() => {
            navigate('/dashboard')
          }, 3000);
        } else {
          setAccessDenied(false);
        }
      });
  }, [id]);

  const isSelected = (param) => selectedParams.includes(param);

  // Progressive rendering for the team-statistics section (default outer tab).
  // Like the player table, it renders every selected parameter row at once; on
  // heavy matches that is a large synchronous block. Reveal rows in animation-
  // frame batches so no single frame is expensive. teamRowOffsets holds the
  // cumulative count of selected rows before each group, so we can cap by row.
  const { teamRowOffsets, totalTeamRows } = useMemo(() => {
    const offsets = [];
    let running = 0;
    (teamParamsList || []).forEach(([key, values]) => {
      offsets.push(running);
      if (selectedParams.includes(key)) {
        running += values?.length || 0;
      }
    });
    return { teamRowOffsets: offsets, totalTeamRows: running };
  }, [teamParamsList, selectedParams]);

  const [visibleTeamRows, setVisibleTeamRows] = useState(0);
  const teamRafRef = useRef(null);

  useEffect(() => {
    if (teamRafRef.current) {
      cancelAnimationFrame(teamRafRef.current);
      teamRafRef.current = null;
    }
    if (totalTeamRows === 0) {
      setVisibleTeamRows(0);
      return undefined;
    }

    const batch = 24;
    let current = Math.min(batch, totalTeamRows);
    setVisibleTeamRows(current);

    const step = () => {
      current = Math.min(current + batch, totalTeamRows);
      setVisibleTeamRows(current);
      teamRafRef.current =
        current < totalTeamRows ? requestAnimationFrame(step) : null;
    };

    if (current < totalTeamRows) {
      teamRafRef.current = requestAnimationFrame(step);
    }

    return () => {
      if (teamRafRef.current) {
        cancelAnimationFrame(teamRafRef.current);
        teamRafRef.current = null;
      }
    };
  }, [totalTeamRows]);

  const handleParameterSelect = (param) => {
    if (isSelected(param)) {
      setSelectedParams(selectedParams.filter((p) => p !== param));
    } else {
      setSelectedParams([...selectedParams, param]);
    }
  };

  // const navigate = useNavigate();


  useEffect(() => {
    const setParams = async () => {
      setPlayerFiltersLoading(true);
      try {
        let params = null;
        if (sessionStorage.getItem('playerParameters')) {
          params = JSON.parse(sessionStorage.getItem('playerParameters'))
          const activeSelection = getActiveParameterSelection(params);
          setGkPlayerSelectedFilters(activeSelection);
          setPlayerSelectedFilters(activeSelection);
          // Re-fetch with the stored param IDs — this supersedes the initial
          // empty-params call made in useEffect([id]).
          getPlayerStats(id, activeSelection.checkedIds);
        } else {
          const response = await $apiV1.get('/stats/parameters/player');
          const data = response.data?.results;
          if (data) {
            params = getGroupedAndSortedParametrs(data, true);
            const activeSelection = getActiveParameterSelection(params);
            setGkPlayerSelectedFilters(activeSelection);
            setPlayerSelectedFilters(activeSelection);
            // Re-fetch with the real param IDs now that we have them.
            getPlayerStats(id, activeSelection.checkedIds);
          }
        }
      } catch (e) {
        console.log(`Error in receiving player parameters. ${e.message}`)
      } finally {
        setPlayerFiltersLoading(false);
      }
    }
    setParams();
  }, [])

  useEffect(() => {
    if (playerStats?.players_stats?.home_team.length) {
      setSelectedOutfieldHomePlayer(playerStats.players_stats.home_team[0]);
      const gk = playerStats.players_stats.home_team.find((item) =>
        item.positions.includes("GK")
      );

      if (gk) {
        setSelectedGkHomePlayer(gk);
      }
    }
    if (playerStats?.players_stats?.away_team.length) {
      setSelectedOutfieldAwayPlayer(playerStats.players_stats.away_team[0]);
      const gk = playerStats.players_stats.away_team.find((item) =>
        item.positions.includes("GK")
      );

      if (gk) {
        setSelectedGkAwayPlayer(gk);
      }
    }
  }, [playerStats]);

  // Handler for home team player change
  const handleHomePlayerChange = (data) => {
    setSelectedOutfieldHomePlayer(data);
  };

  // Handler for away team player change
  const handleAwayPlayerChange = (data) => {
    setSelectedOutfieldAwayPlayer(data);
  };

  function filterPlayers(players) {
    return (players || []).filter(({ positions }) => !positions.includes("GK"));
  };

  function filterGK(players) {
    return (players || []).filter(({ positions }) => positions.includes("GK"));
  };

  // Find selected home player stats
  const homePlayer = useMemo(
    () =>
      playerStats?.players_stats?.home_team.find(
        (player) => String(player.id) === `${selectedOutfieldHomePlayer?.id}`
      ),
    [playerStats, selectedOutfieldHomePlayer]
  );

  // Find selected away player stats
  const awayPlayer = useMemo(
    () =>
      playerStats?.players_stats?.away_team.find(
        (player) => String(player.id) === `${selectedOutfieldAwayPlayer?.id}`
      ),
    [playerStats, selectedOutfieldAwayPlayer]
  );

  // Find selected home gk player stats
  const homeGkPlayer = useMemo(
    () =>
      playerStats?.players_stats?.home_team.find(
        (player) => String(player.id) === `${selectedGkHomePlayer?.id}`
      ),
    [playerStats, selectedGkHomePlayer]
  );

  // Find selected away gk player stats
  const awayGkPlayer = useMemo(
    () =>
      playerStats?.players_stats?.away_team.find(
        (player) => String(player.id) === `${selectedGkAwayPlayer?.id}`
      ),
    [playerStats, selectedGkAwayPlayer]
  );

  // Index stats by parameter_name so the render can look them up in O(1).
  // Previously each parameter cell ran a linear .find() over the full stat
  // array, making the render O(parameters x stats x players) and freezing the
  // main thread for several seconds (Chrome "Page Unresponsive") on heavy matches.
  const homeStatByName = useMemo(
    () => statsByParameterName(matchesWithStatHome),
    [matchesWithStatHome]
  );
  const awayStatByName = useMemo(
    () => statsByParameterName(matchesWithStatAway),
    [matchesWithStatAway]
  );
  const homePlayerStatByName = useMemo(
    () => statsByParameterName(homePlayer?.stats),
    [homePlayer]
  );
  const awayPlayerStatByName = useMemo(
    () => statsByParameterName(awayPlayer?.stats),
    [awayPlayer]
  );
  const homeGkStatByName = useMemo(
    () => statsByParameterName(homeGkPlayer?.stats),
    [homeGkPlayer]
  );
  const awayGkStatByName = useMemo(
    () => statsByParameterName(awayGkPlayer?.stats),
    [awayGkPlayer]
  );

  const getTeamParams = async () => {
    try {
      const response = await $apiV1.get(`/stats/parameters/team`);
      const data = response?.data?.results;
      if (data) {
        const params = getGroupedAndSortedParametrs(
          excludeAttackingTypesParameters(data)
        );
        getMatchStat(id, params);
        setTeamParamsList(params);
      }
    } catch (error) {
      console.error("Error fetching players:", error);
    } finally {
    }
  };

  const getPlayerParams = async () => {
    try {
      const response = await $apiV1.get(`/stats/parameters/player`);
      const data = response?.data?.results;
      if (data) {
        const params = getGroupedAndSortedParametrs(data);
        setPlayerParamsList(params);
        const gkParamIds = goalkeepersModalParams.map((item) => item.paramId);
        const playerGkParams = data.filter((item) =>
          gkParamIds.includes(item.id)
        );
        setPlayerGkParams(getGroupedAndSortedParametrs(playerGkParams));
      }
    } catch (error) {
      console.error("Error fetching players:", error);
    } finally {
    }
  };

  const getStats = async (id) => {
    try {
      setLoading(true);
      const response = await $apiV1.get(`/platform/match_detail/${id}/events`);
      setStats(response?.data);
    } catch (error) {
      console.error("Error fetching players:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    setXmlFileName(stats?.match?.home_team + '_' + stats?.match?.away_team + '_' + today + '.xml');
  }, [stats]);

  const getMatchStat = async (id, params, downloadType) => {
    try {
      setLoading(true);
      let allParams = [];
      params.forEach(([_, value]) => {
        allParams = [...allParams, ...value];
      });
      allParams = allParams?.filter((param) => param.checked);
      const paramsIds = allParams?.map((item) => item.id);
      if (downloadType) {
        const downloadNotifId = 'downloading-match-stat';
        addNotification('Downloading...', 'info', { id: downloadNotifId, duration: 0 });
        try {
          if (downloadType === 'xml') {
            await $apiV1.get(
              `/stats/match_teams/${id}?params=${paramsIds?.join(",")}&format_data=${downloadType}`,
              { responseType: 'blob' }
            ).then(response => {
                const blob = new Blob([response.data], { type: 'application/xml' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = xmlFileName;
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
              });
          } else {
            const file = await $apiV1.get(
              `/stats/match_teams/${id}?params=${paramsIds?.join(",")}&format_data=${downloadType}`
            );
            const a = document.createElement("a");
            a.href = file.data.file_url;
            a.download =
              file.data.file_url.split("/")[
              file.data.file_url.split("/").length - 1
              ];
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }
        } finally {
          removeNotification(downloadNotifId);
        }
        return
      } else {
        const response = await $apiV1.get(
          `/stats/match_teams/${id}?params=${paramsIds?.join(",")}`
        );
        setMatchStat(response?.data);
        const dataHome = response.data?.teams_stats?.home_team?.stats;
        const dataAway = response.data?.teams_stats?.away_team?.stats;
        setMathesWithStatHome(dataHome);
        setMathesWithStatAway(dataAway);
      }
    } catch (error) {
      console.error("Error fetching players:", error);
    } finally {
      setLoading(false);
    }
  };

  const getXml = async (id) => {
    const downloadNotifId = 'downloading-xml';
    addNotification('Downloading...', 'info', { id: downloadNotifId, duration: 0 });
    try {
      setLoading(true);
      const response = await $apiV1.post(`/statistics/match_xml`, { file_type: 'xml', match: id },   { responseType: 'blob' });
      const blob = new Blob([response.data], { type: 'application/xml' }); // or application/octet-stream
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `match-${id}.xml`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Error fetching players:", error);
    } finally {
      setLoading(false);
      removeNotification(downloadNotifId);
    }
  }

  const getPlayerStats = async (id, params = [], downloadType) => {
    const shouldLoadPlayerStats = !downloadType;
    // Increment the call counter so stale responses from earlier calls are ignored.
    const callId = ++playerStatsCallId.current;

    try {
      if (shouldLoadPlayerStats) {
        setPlayerStatsLoading(true);
        setPlayerStats(undefined);
      }
      setLoading(true);
      let currentParams = params;
      if (sessionStorage.getItem("playerParameters") && params?.length === 0) {
        try {
          const stored = JSON.parse(sessionStorage.getItem("playerParameters"));
          currentParams = getActiveParameterSelection(stored).checkedIds;
        } catch (e) {
          sessionStorage.removeItem("playerParameters");
        }
      }
      if (downloadType) {
        const downloadNotifId = 'downloading-player-stat';
        addNotification('Downloading...', 'info', { id: downloadNotifId, duration: 0 });
        try {
          const file = await $apiV1.get(`/stats/match_players/${id}?params_ids=${currentParams.join(",")}&format_data=${downloadType}`);
          if (downloadType === 'xml') {
            const response = await fetch(file.data.file_url);
            if (!response.ok) throw new Error('Network response was not ok');
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = file.data.file_url.split("/")[
              file.data.file_url.split("/").length - 1
            ];
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          } else {
            const a = document.createElement("a");
            a.href = file.data.file_url;
            a.download =
              file.data.file_url.split("/")[
              file.data.file_url.split("/").length - 1
              ];
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }
        } finally {
          removeNotification(downloadNotifId);
        }
        return
      } else {
        const response = await $apiV1.get(`/stats/match_players/${id}?params_ids=${currentParams.join(",")}`);
        // Only apply result if no newer call has been made since this one started.
        if (callId === playerStatsCallId.current) {
          setPlayerStats(response?.data);
        }
      }

    } catch (error) {
      console.error("Error fetching players:", error);
    } finally {
      if (shouldLoadPlayerStats && callId === playerStatsCallId.current) {
        setPlayerStatsLoading(false);
      }
      setLoading(false);
    }
  };

  //   ------

  function downloadFile(url, fileName) {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        const downloadLink = document.createElement("a");
        downloadLink.href = blobUrl;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        window.URL.revokeObjectURL(blobUrl); // Освобождение ресурсов
      })
      // eslint-disable-next-line no-console
      .catch((e) => console.error("Error downloading file:", e));
  }

  const postSelectedMatchesEventsXML = async () => {
    if (!id) {
      return;
    }
    const downloadNotifId = 'downloading-events-xml';
    addNotification('Downloading...', 'info', { id: downloadNotifId, duration: 0 });
    try {
      const response = await $apiV1.post("/statistics/match_event_unload", {
        file_type: "xml",
        matches: [id],
      });
      const fileUrl = response.data?.file_url;
      downloadFile(
        `https://api-v0.smrtstats.com/${fileUrl}`,
        fileUrl.split("/")[
        fileUrl.split("/").length - 1
        ]
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    } finally {
      removeNotification(downloadNotifId);
    }
  };

  const handleDownload = () => {
    postSelectedMatchesEventsXML();
  };

  const handleDownloadReport = async () => {
    if (!stats?.match?.id || isDownloadingReport) return;
    const notifId = 'downloading-report';
    setIsDownloadingReport(true);
    addNotification('Download in progress...', 'info', { id: notifId, duration: 0 });
    try {
      const response = await $apiV2.post(
        `/platform/match/${stats.match.id}/export/report/pdf`,
        {},
        { responseType: 'blob' }
      );
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.download = `match-report-${stats.match.id}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error('Report download failed', e);
      addNotification('Error, please try again later.', 'error');
    } finally {
      removeNotification(notifId);
      setIsDownloadingReport(false);
    }
  };

  useEffect(() => {
    getStats(id);
    getPlayerParams();
    getTeamParams();
    // Always trigger an initial load. If params are available in sessionStorage they
    // will be picked up inside getPlayerStats; otherwise setParams will re-trigger
    // with the proper param IDs once the parameters API responds.
    // The callId ref inside getPlayerStats ensures the later (better) call wins.
    getPlayerStats(id);
  }, [id]);

  useEffect(() => { }, []);

  const [tempSelectedFilters, setTempSelectedFilters] = useState([]);

  const getTeamParameterDisplayName = useMemo(
    () =>
      createTranslatedParameterNameResolver(getTeamParameterLexiconId, l),
    [getTeamParameterLexiconId, l]
  );

  const getPlayerParameterDisplayName = useMemo(
    () =>
      createTranslatedParameterNameResolver(getPlayerParameterLexiconId, l),
    [getPlayerParameterLexiconId, l]
  );

  const getMatchEventDisplayName = useMemo(
    () => (actionInput) => resolveMatchEventLabel(actionInput, { l, t }),
    [l, t]
  );

  // Pre-compute everything each marker row needs to render, once, instead of
  // calling label/description/video-title resolvers per row on every render.
  // This is the main driver of the "page unresponsive" freeze on heavy matches.
  const markersView = useMemo(() => {
    const markers = stats?.markers;
    if (!Array.isArray(markers)) {
      return [];
    }
    return markers.map((item) => {
      const roundedSeconds = Math.round(item.second);
      const actionTitle = item?.action?.title;
      const hasCreator = Boolean(item?.creator);
      return {
        id: item.id,
        label: getMatchEventDisplayName(item?.action),
        minutes: Math.floor(roundedSeconds / 60),
        remainingSeconds: roundedSeconds % 60,
        description: buildMatchEventDescription(item, { l, t }),
        videoTitle: buildMatchEventVideoTitle(item, { l, t }),
        iconSrc: MATCH_EVENT_ICONS[actionTitle] || "",
        hasCreator,
        teamLogo: hasCreator ? getMediaUrl(item?.team_logo) : null,
        creatorPhoto: hasCreator ? getMediaUrl(item?.creator?.photo) : null,
        isSubstitution: actionTitle === "Substitution",
        recipientPhoto: item?.recipient?.photo
          ? getMediaUrl(item?.recipient?.photo)
          : null,
      };
    });
  }, [stats?.markers, getMatchEventDisplayName, l, t]);

  const handleFilterChange = (id) => {
    setTempSelectedFilters((prevIds) => {
      if (prevIds.includes(id)) {
        return prevIds.filter((item) => item !== id);
      } else {
        return [...prevIds, id];
      }
    });
  };

  const displayFilters = () => {
    let displayedParams = typePlayerStat === 'gk' ? gkPlayerSelectedFilters : playerSelectedFilters;

    if (displayedParams?.params?.length === 0) {
      return "Choose params";
    }

    const firstTwo = displayedParams?.params?.slice(0, 2)?.map(param => getPlayerParameterDisplayName(param))?.join(", ");
    const additionalCount = displayedParams?.params?.length - 2;
    return additionalCount > 0 ? `${firstTwo}, +${additionalCount}` : firstTwo;
  };

  const handleClearFilter = () => {
    setTempSelectedFilters("");
  };

  const handleGroupFilterChange = (keywords) => {
    const items = playerStats?.players_stats.away_team[0]?.stats.filter(
      (item) =>
        keywords.some((keyword) => item.parameter_name.includes(keyword))
    );
    const allSelected = areAllSelected(keywords);

    if (allSelected) {
      // Deselect all items in the group
      const newFilters = tempSelectedFilters.filter(
        (filter) => !items.some((item) => item.parameter_name === filter)
      );
      setTempSelectedFilters(newFilters);
    } else {
      // Select all items in the group
      const newFilters = [
        ...tempSelectedFilters,
        ...items.map((item) => item.parameter_name),
      ];
      setTempSelectedFilters([...new Set(newFilters)]);
    }
  };

  const areAllSelected = (keywords) => {
    const items = playerStats?.players_stats.away_team[0]?.stats.filter(
      (item) =>
        keywords.some((keyword) => item.parameter_name.includes(keyword))
    );
    return items.every((item) =>
      tempSelectedFilters.includes(item.parameter_name)
    );
  };

  function handleChangePlayerParams(params) {
    const activeSelection = getActiveParameterSelection(params);
    if (typePlayerStat === 'gk') {
      setGkPlayerSelectedFilters(activeSelection)

    } else {
      setPlayerSelectedFilters(activeSelection)
    }
    // getPlayerStats?.(id, checkedIds);
  }

  const [navigationOpen, setNavigationOpen] = useState(
    localStorage.getItem("navigationOpen")
  );

  useEffect(() => {
    const handleNavigationOpenChange = () => {
      setNavigationOpen(localStorage.getItem("navigationOpen"));
      console.log(localStorage.getItem("navigationOpen"), "ss");
    };

    window.addEventListener("navigationOpenChange", handleNavigationOpenChange);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener(
        "navigationOpenChange",
        handleNavigationOpenChange
      );
    };
  }, []);

  const outfieldHomePlayersDropdownRef = useOutsideClick(() => {
    if (openOutfieldHomePlayers) {
      setOpenOutfieldHomePlayers(false);
    }
  });

  const outfieldAwayPlayersDropdownRef = useOutsideClick(() => {
    if (openOutfieldAwayePlayers) {
      setOpenOutfieldAwayPlayers(false);
    }
  });

  const gkHomePlayersDropdownRef = useOutsideClick(() => {
    if (openGkHomePlayers) {
      setOpenGkHomePlayers(false);
    }
  });

  const gkAwayPlayersDropdownRef = useOutsideClick(() => {
    if (openGkAwayePlayers) {
      setOpenGkAwayPlayers(false);
    }
  });

  const [isMetricaPopupOpen, setIsMetricaPopupOpen] = useState(false);
  const [metricaPopupMessage, setMetricaPopupMessage] = useState("");
  const isPlayerStatsPanelLoading = playerStatsLoading || playerFiltersLoading;
  const hasMatchVideo = Boolean(
    stats?.match?.video || stats?.match?.videos?.some((video) => Boolean(video?.link))
  );

  const handleCloseMetricaPopup = () => {
    setIsMetricaPopupOpen(false);
    setMetricaPopupMessage("");
  };

  const handleMetrica = async () => {
    if (!hasMatchVideo) {
      return;
    }
    try {
      await $apiV2.get(
        `/metrica/${stats?.match?.id}`,
      );

      setMetricaPopupMessage(
        "Metrica Nexus Container download started, you will receive the container via email."
      );
      setIsMetricaPopupOpen(true);
    } catch (err) {
      addNotification('Error, please try again later.', 'error');
    }
  }

  return (
    <MainWrapper>
      <Navigation />
      <MainWrapperFavorite
        className={
          localStorage.getItem("navigationOpen") === "true"
            ? ""
            : "fullWidthPage"
        }
        style={accessDenied ? { overflow: 'hidden' } : undefined}
      >
        <TeamPageContainer>
        {accessDenied && (
          <AccessDenied>
            {l(1119)}
          </AccessDenied>
        )}
        <TopWrapper>
          <IntroText
            smallTitle={t("favorites.smallTitle")}
            title={l(1681) || l(1015)}
          />
          <Search />
        </TopWrapper>
        <TeamCardWrap>
          <TeamContent>
            <TopContent>
              <Info style={{ alignItems: "center" }}>
                <img
                  src={stats?.match?.competition_logo || placeholder}
                  alt={placeholder}
                />{" "}
                <TeamLeftInfo>
                  <h5>
                    {" "}
                    <Moment format="DD.MM.YYYY">{stats?.match?.date}</Moment>
                  </h5>
                  <h2
                    className="statText"
                    onClick={() => matchInfo?.season?.season_id && window.open(`/tournaments?seasonId=${matchInfo?.season?.season_id}`)}>
                    {stats?.match?.competition}
                  </h2>
                </TeamLeftInfo>
              </Info>

              <TeamButtons>
                <Button
                  onClick={() => setOpenFormation(true)}
                  title={l(119)}
                  color={"secondary"}
                />
                <Button
                  disabled={!stats?.match?.id}
                  onClick={() =>
                    window.open(`/tournaments/match/video/${stats?.match?.id}`, "_blank")
                  }
                  title={l(118)}
                />
                {canDownloadReport === true && (
                  <Button
                    disabled={!stats?.match?.id || isDownloadingReport}
                    onClick={handleDownloadReport}
                    title={isDownloadingReport ? l(312) : t("statistics.downloadReport")}
                    color={"secondary"}
                  />
                )}
              </TeamButtons>  
            </TopContent>
            <BottomContent>
              <Result>
                <TeamInfo>
                  <img
                    src={stats?.match?.home_team_logo || placeholder}
                    alt={stats?.match?.home_team || placeholder}
                  />
                  <a
                    data-tooltip-id={`full-name-${stats?.match?.home_team_id}`}
                    href={`/tournaments/team/${stats?.match?.home_team_id}`}
                    target="_blank" rel="noreferrer"
                  >
                    {stats?.match?.home_team}
                  </a>

                  <ReactTooltip
                    id={`full-name-${stats?.match?.home_team_id}`}
                    place="bottom"
                    content={stats?.match?.home_team}
                  />
                </TeamInfo>
                <h5>{formatMatchScore(stats?.match)}</h5>
                <TeamInfo className="reverse">
                  <img
                    src={stats?.match?.away_team_logo || placeholder}
                    alt={stats?.match?.away_team || placeholder}
                  />
                  <a
                    data-tooltip-id={`full-name-${stats?.match?.away_team_id}`}
                    href={`/tournaments/team/${stats?.match?.away_team_id}`}
                    target="_blank" rel="noreferrer"
                  >
                    {stats?.match?.away_team}
                  </a>
                  <ReactTooltip
                    id={`full-name-${stats?.match?.away_team_id}`}
                    place="bottom"
                    content={stats?.match?.away_team}
                  />
                </TeamInfo>
              </Result>
            </BottomContent>
          </TeamContent>
        </TeamCardWrap>

        {isMetricaPopupOpen && (
          <PopupOverlay onClick={handleCloseMetricaPopup}>
            <PopupContent onClick={(e) => e.stopPropagation()}>
              <PopupMessage>{metricaPopupMessage}</PopupMessage>
              <PopupActions>
                <Button
                  title="Close"
                  onClick={handleCloseMetricaPopup}
                  size={"full"}
                />
              </PopupActions>
            </PopupContent>
          </PopupOverlay>
        )}

        <StatCardsWrap>
          <StatCard>
            <TopStatCard>
              <h2>{l(99)}</h2>
              <button onClick={() => setOpenFilter(!openFilter)}>{l(1018)}</button>
            </TopStatCard>
            <InnerCardInfo>
              <TabsWrapper>
                <TopList style={{ padding: "10px" }}>
                  <TabListWrapper>
                    <TabTitle>{l(3)}</TabTitle>
                    <TabTitle>{l(1084)}</TabTitle>
                    <TabTitle>{l(1011)}</TabTitle>
                  </TabListWrapper>
                </TopList>

                {/* Team Tab */}
                <TabContent>
                  <div style={{ display: 'flex', gap: 5, padding: '0 0 10px 10px' }}>
                    <DownloadXml>
                      <button onClick={() => getMatchStat(id, teamParamsList, 'xls')}>
                        {l(14)}
                      </button>
                    </DownloadXml>
                    <DownloadXml>
                      <button onClick={() => getMatchStat(id, teamParamsList, 'xml')}>
                      {l(339)}
                      </button>
                    </DownloadXml>
                    {hasMatchVideo && (
                      <DownloadXml title={l(1126)}>
                        <button
                          title={l(1126)}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: '10px',
                          }}
                          onClick={handleMetrica}
                        >
                          <img style={{width: '20px', height: '20px'}} src={metricaBlack} alt="Metrica" />
                          {l(1125)}
                        </button>
                      </DownloadXml>
                    )}
                  </div>
                  <TeamStatInfo>
                    {teamParamsList?.map(([key, values], index) => {
                      if (!isSelected(key)) return null;
                      // Skip groups not yet revealed by the progressive ramp.
                      if (teamRowOffsets[index] >= visibleTeamRows) return null;
                      const translatedGroupName = getTeamParameterDisplayName(key);
                      return (
                        <React.Fragment key={key}>
                          <TopTeamNames>
                            {index === 0 && (
                              <a
                                href={`/tournaments/team/${matchStat?.teams_stats?.home_team?.id}`}
                              >
                                {matchStat?.teams_stats?.home_team?.name}
                              </a>
                            )}
                            {index === 0 && (
                              <a
                                href={`/tournaments/team/${matchStat?.teams_stats?.away_team?.id}`}
                              >
                                {matchStat?.teams_stats?.away_team?.name}
                              </a>
                            )}
                          </TopTeamNames>
                          <TeamStatHeader>
                            <h5 className={index === 0 ? "" : "aboveSpace"}>
                              {translatedGroupName}
                            </h5>
                          </TeamStatHeader>

                          <TeamInfoStat>
                            {values?.map(({ name }, valueIndex) => {
                              // Cap value rows to the progressive ramp so the
                              // whole grid never builds in one synchronous frame.
                              if (teamRowOffsets[index] + valueIndex >= visibleTeamRows) {
                                return null;
                              }
                              const displayName = getTeamParameterDisplayName(name);
                              const tmpHome = homeStatByName.get(name);
                              const tmpAway = awayStatByName.get(name);
                              const markersHome = tmpHome?.markers?.join(",");
                              const markersAway = tmpAway?.markers?.join(",");
    
                              const sHome = tmpHome?.value ?? "0";
                              const sAway = tmpAway?.value ?? "0";
                              return (
                                <InfoStat
                                  key={name}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px",
                                  }}
                                >
                                  <h5
                                    onClick={() => openVideoList(markersHome, `${displayName} - ${matchStat?.teams_stats?.home_team?.name}`, true)}
                                    onContextMenu={() =>
                                      openVideoList(markersHome, `${displayName} - ${matchStat?.teams_stats?.home_team?.name}`, true)
                                    }
                                    style={{
                                      cursor:
                                        tmpHome?.markers?.length > 0 &&
                                        "pointer",
                                    }}
                                  >
                                    {Number.isInteger(sHome)
                                      ? sHome.toLocaleString()
                                      : typeof sHome === "number"
                                        ? sHome.toFixed(1)
                                      : sHome}
                                  </h5>
                                  <h5>{displayName}</h5>
                                  <h5
                                    onClick={() => openVideoList(markersAway, `${displayName} - ${matchStat?.teams_stats?.away_team?.name}`, true)}
                                    onContextMenu={() =>
                                      openVideoList(markersAway, `${displayName} - ${matchStat?.teams_stats?.away_team?.name}`, true)
                                    }
                                    style={{
                                      cursor:
                                        tmpAway?.markers?.length > 0 &&
                                        "pointer",
                                    }}
                                  >


                                    {Number.isInteger(sAway)
                                      ? sAway.toLocaleString()
                                      : typeof sAway === "number"
                                        ? sAway.toFixed(1)
                                        : sAway}
                                  </h5>
                                </InfoStat>
                              );
                            })}
                          </TeamInfoStat>
                        </React.Fragment>
                      );
                    })}
                  </TeamStatInfo>
                </TabContent>

                {/* Players Tab */}
                <TabContent>
                  <TeamStatInfo>
                    <TopTeamNames>
                      {/* <select
                        onChange={handleHomePlayerChange}
                        value={selectedHomePlayer}
                      >
                        {filterPlayers(
                          playerStats?.players_stats?.home_team
                        ).map((item) => (
                          <option key={item.id} value={String(item.id)}>
                            {item.display_name || `${item.name} ${item.surname}`}
                          </option>
                        )) || <option value="">No Home Players</option>}
                      </select> */}
                      <DropdownWrapper ref={outfieldHomePlayersDropdownRef} style={{ marginBottom: 10, marginLeft: 10 }}>
                        <div
                          style={{
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10
                          }}
                          onClick={() => setOpenOutfieldHomePlayers(!openOutfieldHomePlayers)}
                        >
                          <TextInput
                            type="text"
                            value={
                              selectedOutfieldHomePlayer?.name ?
                                `${selectedOutfieldHomePlayer.name} ${selectedOutfieldHomePlayer.surname}`
                                : ''
                            }
                            readOnly
                          />
                          <img
                            src={openOutfieldHomePlayers ? arrowIconUp : arrowIconDown}
                            alt={arrowIconDown}
                            style={{
                              color: "#fff",
                              position: "absolute",
                              right: 0,
                              cursor: "pointer",
                            }}
                          />
                        </div>
                        {openOutfieldHomePlayers && (
                          <OpenedDropdown>
                            {filterPlayers(
                              playerStats?.players_stats?.home_team
                            )?.map((item) => (
                              <div
                                key={item.id}
                                onClick={() => { handleHomePlayerChange(item); setOpenOutfieldHomePlayers(false) }}
                              >
                                {item.display_name || `${item.name} ${item.surname}`}
                              </div>
                            ))}
                          </OpenedDropdown>
                        )}
                      </DropdownWrapper>
                      <DropdownWrapper ref={outfieldAwayPlayersDropdownRef} style={{ marginBottom: 10, marginRight: 10 }}>
                        <div
                          style={{
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10
                          }}
                          onClick={() => setOpenOutfieldAwayPlayers(!openOutfieldAwayePlayers)}
                        >
                          <TextInput
                            type="text"
                            value={
                              selectedOutfieldAwayPlayer?.name ?
                                `${selectedOutfieldAwayPlayer.name} ${selectedOutfieldAwayPlayer.surname}`
                                : ''
                            }
                            readOnly
                          />
                          <img
                            src={openOutfieldAwayePlayers ? arrowIconUp : arrowIconDown}
                            alt={arrowIconDown}
                            style={{
                              color: "#fff",
                              position: "absolute",
                              right: 0,
                              cursor: "pointer",
                            }}
                          />
                        </div>
                        {openOutfieldAwayePlayers && (
                          <OpenedDropdown>
                            {filterPlayers(
                              playerStats?.players_stats?.away_team
                            )?.map((item) => (
                              <div
                                key={item.id}
                                onClick={() => { handleAwayPlayerChange(item); setOpenOutfieldAwayPlayers(false) }}
                              >
                                {item.display_name || `${item.name} ${item.surname}`}
                              </div>
                            ))}
                          </OpenedDropdown>
                        )}
                      </DropdownWrapper>
                      {/* <select
                        onChange={handleAwayPlayerChange}
                        value={selectedAwayPlayer}
                      >
                        {filterPlayers(
                          playerStats?.players_stats?.away_team
                        ).map((item) => (
                          <option key={item.id} value={String(item.id)}>
                            {item.display_name || `${item.name} ${item.surname}`}
                          </option>
                        )) || <option value="">No Away Players</option>}
                      </select> */}
                    </TopTeamNames>

                    {playerParamsList?.map(([key, values]) => {
                      if (key === "Without group") return null;
                      const translatedGroupName = getPlayerParameterDisplayName(key);
                      return (
                        <React.Fragment key={key}>
                          <TeamStatHeader style={{ width: "100%" }}>
                            <h5 className={"aboveSpace"}>{translatedGroupName}</h5>
                          </TeamStatHeader>
                          <TeamInfoStat>
                            {values?.map(({ name }) => {
                              const displayName = getPlayerParameterDisplayName(name);
                              const tmpHome = homePlayerStatByName.get(name);
                              const tmpAway = awayPlayerStatByName.get(name);
                              const markersHome = tmpHome?.markers?.join(",");
                              const markersAway = tmpAway?.markers?.join(",");
                              
                              const sHome = tmpHome?.value ?? "0";
                              const sAway = tmpAway?.value ?? "0";
                              return (
                                <InfoStat
                                  key={name}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px",
                                  }}
                                >
                                  <h5
                                    onClick={() => openVideoList(markersHome, `${displayName} - ${homePlayer?.name} ${homePlayer?.surname}`, true)}
                                    onContextMenu={() =>
                                      openVideoList(markersHome, `${displayName} - ${homePlayer?.name} ${homePlayer?.surname}`, true)
                                    }
                                    style={{
                                      cursor:
                                        tmpHome?.markers?.length > 0 &&
                                        "pointer",
                                    }}
                                  >
                                    {Number.isInteger(sHome)
                                      ? sHome.toLocaleString()
                                      : typeof sHome === "number"
                                        ? sHome.toFixed(1)
                                      : sHome}
                                  </h5>
                                  <h5>{displayName}</h5>
                                  <h5
                                    onClick={() => openVideoList(markersAway, `${displayName} - ${awayPlayer?.name} ${awayPlayer?.surname}`, true)}
                                    onContextMenu={() =>
                                      openVideoList(markersAway, `${displayName} - ${awayPlayer?.name} ${awayPlayer?.surname}`, true)
                                    }
                                    style={{
                                      cursor:
                                        tmpAway?.markers?.length > 0 &&
                                        "pointer",
                                    }}
                                  >


                                    {Number.isInteger(sAway)
                                      ? sAway.toLocaleString()
                                      : typeof sAway === "number"
                                        ? sAway.toFixed(1)
                                        : sAway}
                                  </h5>
                                </InfoStat>
                              );
                            })}
                          </TeamInfoStat>
                        </React.Fragment>
                      );
                    })}
                  </TeamStatInfo>
                </TabContent>

                {/* GoalKeeper Tab */}
                <TabContent>
                  <TeamStatInfo>
                    <TopTeamNames>
                      <DropdownWrapper ref={gkHomePlayersDropdownRef} style={{ marginBottom: 10, marginLeft: 10 }}>
                        <div
                          style={{
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10
                          }}
                          onClick={() => setOpenGkHomePlayers(!openGkHomePlayers)}
                        >
                          <TextInput
                            type="text"
                            value={
                              selectedGkHomePlayer?.name ?
                                `${selectedGkHomePlayer.name} ${selectedGkHomePlayer.surname}`
                                : ''
                            }
                            readOnly
                          />
                          <img
                            src={openGkHomePlayers ? arrowIconUp : arrowIconDown}
                            alt={arrowIconDown}
                            style={{
                              color: "#fff",
                              position: "absolute",
                              right: 0,
                              cursor: "pointer",
                            }}
                          />
                        </div>
                        {openGkHomePlayers && (
                          <OpenedDropdown>
                            {filterGK(
                              playerStats?.players_stats?.home_team
                            )?.map((item) => (
                              <div
                                key={item.id}
                                onClick={() => { setSelectedGkHomePlayer(item); setOpenGkHomePlayers(false) }}
                              >
                                {item.display_name || `${item.name} ${item.surname}`}
                              </div>
                            ))}
                          </OpenedDropdown>
                        )}
                      </DropdownWrapper>
                      <DropdownWrapper ref={gkAwayPlayersDropdownRef} style={{ marginBottom: 10, marginRight: 10 }}>
                        <div
                          style={{
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10
                          }}
                          onClick={() => setOpenGkAwayPlayers(!openGkAwayePlayers)}
                        >
                          <TextInput
                            type="text"
                            value={
                              selectedGkAwayPlayer?.name ?
                                `${selectedGkAwayPlayer.name} ${selectedGkAwayPlayer.surname}`
                                : ''
                            }
                            readOnly
                          />
                          <img
                            src={openGkAwayePlayers ? arrowIconUp : arrowIconDown}
                            alt={arrowIconDown}
                            style={{
                              color: "#fff",
                              position: "absolute",
                              right: 0,
                              cursor: "pointer",
                            }}
                          />
                        </div>
                        {openGkAwayePlayers && (
                          <OpenedDropdown>
                            {filterGK(
                              playerStats?.players_stats?.away_team
                            )?.map((item) => (
                              <div
                                key={item.id}
                                onClick={() => { setSelectedGkAwayPlayer(item); setOpenGkAwayPlayers(false) }}
                              >
                                {item.display_name || `${item.name} ${item.surname}`}
                              </div>
                            ))}
                          </OpenedDropdown>
                        )}
                      </DropdownWrapper>
                      {/* <select
                        onChange={(event) =>
                          setSelectedGkHomePlayer(event.target.value)
                        }
                        value={selectedGkHomePlayer}
                      >
                        {filterGK(playerStats?.players_stats?.home_team).map(
                          (item) => (
                            <option key={item.id} value={String(item.id)}>
                              {item.display_name || `${item.name} ${item.surname}`}
                            </option>
                          )
                        ) || <option value="">No Home Players</option>}
                      </select> */}
                      {/* <select
                        onChange={(event) =>
                          setSelectedGkAwayPlayer(event.target.value)
                        }
                        value={selectedGkAwayPlayer}
                      >
                        {filterGK(playerStats?.players_stats?.away_team).map(
                          (item) => (
                            <option key={item.id} value={String(item.id)}>
                              {item.display_name || `${item.name} ${item.surname}`}
                            </option>
                          )
                        ) || <option value="">No Away Players</option>}
                      </select> */}
                    </TopTeamNames>

                    {playerGkParams?.map(([key, values]) => {
                      const translatedGroupName = getPlayerParameterDisplayName(key);
                      return (
                        <React.Fragment key={key}>
                          <TeamStatHeader style={{ width: "100%" }}>
                            <h5 className={"aboveSpace"}>{translatedGroupName}</h5>
                          </TeamStatHeader>
                          <TeamInfoStat>
                            {values?.map(({ name }) => {
                              const displayName = getPlayerParameterDisplayName(name);
                              const tmpHome = homeGkStatByName.get(name);
                              const tmpAway = awayGkStatByName.get(name);
                              const markersHome = tmpHome?.markers?.join(",");
                              const markersAway = tmpAway?.markers?.join(",");
                              
                              const sHome = tmpHome?.value ?? "0";
                              const sAway = tmpAway?.value ?? "0";
                              return (
                                <InfoStat
                                  key={name}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px",
                                  }}
                                >
                                  <h5
                                    onClick={() => openVideoList(markersHome, `${displayName} - ${homeGkPlayer?.name} ${homeGkPlayer?.surname}`, true)}
                                    onContextMenu={() =>
                                      openVideoList(markersHome, `${displayName} - ${homeGkPlayer?.name} ${homeGkPlayer?.surname}`, true)
                                    }
                                    style={{
                                      cursor:
                                        tmpHome?.markers?.length > 0 &&
                                        "pointer",
                                    }}
                                  >
                                    {Number.isInteger(sHome)
                                      ? sHome.toLocaleString()
                                      : typeof sHome === "number"
                                        ? sHome.toFixed(1)
                                      : sHome}
                                  </h5>
                                  <h5>{displayName}</h5>
                                  <h5
                                    onClick={() => openVideoList(markersAway, `${displayName} - ${awayGkPlayer?.name} ${awayGkPlayer?.surname}`, true)}
                                    onContextMenu={() =>
                                      openVideoList(markersAway, `${displayName} - ${awayGkPlayer?.name} ${awayGkPlayer?.surname}`, true)
                                    }
                                    style={{
                                      cursor:
                                        tmpAway?.markers?.length > 0 &&
                                        "pointer",
                                    }}
                                  >


                                    {Number.isInteger(sAway)
                                      ? sAway.toLocaleString()
                                      : typeof sAway === "number"
                                        ? sAway.toFixed(1)
                                        : sAway}
                                  </h5>
                                </InfoStat>
                              );
                            })}
                          </TeamInfoStat>
                        </React.Fragment>
                      );
                    })}
                  </TeamStatInfo>
                </TabContent>
              </TabsWrapper>
            </InnerCardInfo>
          </StatCard>
          <StatCard>
            <TopStatCard>
              <h2>{l(1016)}</h2>
              {/* <button>Filter</button> */}
              {/* <DownloadXml>
                <button onClick={() => handleDownload()}>
                  Download XML
                </button>
              </DownloadXml> */}
            </TopStatCard>
            <MatchEvent style={{ color: "#fff", height: "auto", overflow: "hidden" }}>
              <MathTitle>
                <h3>{l(9)}</h3>
                <h3>{l(466)}</h3>
                <h3>{l(467)}</h3>
              </MathTitle>
              {markersView.length > 0 && (
                <FixedSizeList
                  height={MARKER_LIST_HEIGHT}
                  itemCount={markersView.length}
                  itemSize={MARKER_ROW_HEIGHT}
                  width="100%"
                >
                  {({ index, style }) => {
                    const marker = markersView[index];
                    return (
                      <MatchWrap
                        style={{ ...style, cursor: "pointer" }}
                        $even={index % 2 === 1}
                        onClick={() => openVideoList(marker.id, marker.videoTitle)}
                      >
                        <h5>
                          {marker.iconSrc ? <img src={marker.iconSrc} alt="" /> : null}{" "}
                          {marker.label}{" "}
                        </h5>
                        <h5>
                          {marker.minutes}:{marker.remainingSeconds}
                        </h5>
                        {marker.hasCreator && (
                          <img width={25} src={marker.teamLogo} alt="" />
                        )}
                        {marker.hasCreator && (
                          <img
                            style={{ marginRight: "2px" }}
                            width={25}
                            src={marker.creatorPhoto}
                            alt=""
                          />
                        )}
                        {marker.isSubstitution ? (
                          <>
                            <h5 className="creatorName">{marker.description}</h5>
                            {marker.recipientPhoto && (
                              <img width={25} src={marker.recipientPhoto} alt="" />
                            )}
                          </>
                        ) : (
                          <h5 className="creatorName">{marker.description}</h5>
                        )}
                      </MatchWrap>
                    );
                  }}
                </FixedSizeList>
              )}
            </MatchEvent>
          </StatCard>
        </StatCardsWrap>

        <BottomStatTable>
          <TopStatCard>
            <h2>{l(1017)}</h2>
            <button onClick={() => setOpenPlayerFilter(!openPlayerFilter)}>
              {l(1018)}
            </button>
          </TopStatCard>
          <BottomTableStat>
            <TabsWrapper>
              <TopList style={{ padding: "10px" }}>
                <TabListWrapper>
                  <TabTitle onClick={() => setTypePlayerStat("player")}>
                    {l(1084)}
                  </TabTitle>
                  <TabTitle onClick={() => setTypePlayerStat("gk")}>
                    {l(1011)}
                  </TabTitle>
                </TabListWrapper>
                <div style={{ display: 'flex', gap: 5 }}>
                  <DownloadXml>
                    <button onClick={() => getPlayerStats(id, playerSelectedFilters?.checkedIds, 'xls')}>
                      {l(14)}
                    </button>
                  </DownloadXml>
                  <DownloadXml>
                    <button onClick={() => getXml(id)}>
                      {l(339)}
                    </button>
                  </DownloadXml>
                </div>
              </TopList>

              <TabContent>
                <PlayersStat
                  items={playerStats?.players_stats}
                  club={stats?.match}
                  tempSelectedFilters={tempSelectedFilters}
                  playerSelectedFilters={playerSelectedFilters}
                  loading={isPlayerStatsPanelLoading}
                  getParameterDisplayName={getPlayerParameterDisplayName}
                />
              </TabContent>
              <TabContent>
                <GoalKeeperStat
                  items={playerStats?.players_stats}
                  club={stats?.match}
                  tempSelectedFilters={tempSelectedFilters}
                  gkPlayerSelectedFilters={gkPlayerSelectedFilters}
                  loading={isPlayerStatsPanelLoading}
                  getParameterDisplayName={getPlayerParameterDisplayName}
                />
              </TabContent>
            </TabsWrapper>
          </BottomTableStat>
        </BottomStatTable>

        <Filter
          openFilter={openFilter}
          setOpenFilter={setOpenFilter}
          onClick={() => handleClearFilter()}
        >
          <FormWrap>
            <div style={{ height: "300px", overflow: "scroll" }}>
              <h4>{l(13)}</h4>
              <ParamFilter
                paramsList={teamParamsList}
                isSelected={isSelected}
                handleParameterSelect={handleParameterSelect}
                getDisplayLabel={getTeamParameterDisplayName}
              />
            </div>
          </FormWrap>
        </Filter>

        <Filter
          openFilter={openPlayerFilter}
          setOpenFilter={setOpenPlayerFilter}
          onClick={() => handleClearFilter()}
        >
          <FormWrap>
            <div>
              <h4>{l(13)}</h4>

              <ParamsWrap>
                <InputWrapper>
                  <input
                    type="text"
                    value={displayFilters()}
                    readOnly
                    style={{ width: "100%", marginBottom: "10px" }}
                    onClick={() => setOpenParams(!openParams)}
                  />
                  <img
                    className="dropdownIcon"
                    src={openParams ? arrowIconUp : arrowIconDown}
                    alt={openParams ? arrowIconUp : arrowIconDown}
                    onClick={() => setOpenParams(!openParams)}
                  />
                </InputWrapper>
              </ParamsWrap>
            </div>
            <Button title={l(906)} onClick={() => setOpenPlayerFilter(false)} />
          </FormWrap>
        </Filter>
        </TeamPageContainer>
      </MainWrapperFavorite>

      <ParametersSelector
        type={typePlayerStat}
        open={openParams}
        onClose={() => setOpenParams(false)}
        updateData={handleChangePlayerParams}
      />

      <Formation
        open={openFormation}
        handleClose={() => setOpenFormation(false)}
        match={stats?.match}
      />
       {/* display notifications */}
       <NotificationList
          notifications={notifications}
          onClose={removeNotification}
        />
    </MainWrapper>
  );
};

export default Index;
